const PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const INTERVAL_SLIDE = 8000
const INTERVAL_TRANSITION = 1500
const INTERVAL_TRANSITION_RESET = 50

const RotateImages = {
  mounted() {
    this.track = this.el.querySelector("[data-role='image-track']")
    this.trackLength = this.track.children.length
    this.position = 0

    if (this.trackLength < 3) {
      return
    }

    if (PREFERS_REDUCED_MOTION) {
      this.track.classList.remove('transition-transform', 'duration-500', 'ease-in-out')
    }

    setInterval(() => {
      this.position++;
      this.track.style.transition = `transform ${INTERVAL_TRANSITION}ms ease-in-out`
      this.track.style.transform = `translateX(-${this.position * 100}%)`

      if (this.position === this.trackLength - 1) {
        setTimeout(() => this.reset(), INTERVAL_TRANSITION)
      }
    }, INTERVAL_SLIDE)
  },

  reset() {
    const track = this.track

    this.track.style.transition = 'none'
    this.position = 0
    this.track.style.transform = 'translateX(0%)'

    setTimeout(() => {
      this.track.style.transition = 'transform 1500ms ease-in-out'
    }, INTERVAL_TRANSITION_RESET)

    if (!PREFERS_REDUCED_MOTION) {
      setTimeout(() => {
        track.classList.add('transition-none')
      });
    }
  },
};

export default RotateImages
